<h3 mat-dialog-title class="text-capitalize">Mail {{contextWord}} via USPS</h3>

<mat-dialog-content>
    <p *ngIf="!hasMailingAddress" class="text-center">Choose from the mailing options below. Pricing shown is per letter.</p>
    <div class="row" *ngIf="hasMailingAddress">
        <div class="col-md-6 col-12">
            <label>
                Unit Address:
            </label>
            <div *ngIf="violations[0].unit.address">
                {{violations[0].unit.address.line1}}<br/>
                <span *ngIf="violations[0].unit.address.line2">
                    {{violations[0].unit.address.line1}}<br/>
                </span>
                {{violations[0].unit.address.city}}
                , {{violations[0].unit.address.region}} {{violations[0].unit.address.postalCode}}
                <br/>
            </div>
            <div *ngIf="!violations[0].unit.address">&nbsp;</div>
        </div>
        <div *ngIf="hasMailingAddress" class="col-md-6 col-12">
            <label>
                Owner Mailing Addresses:
            </label>
            <ng-container *ngFor="let owner of violations[0].unit.owners; let last = last">
                <ng-container *ngIf="owner.membership.profile.address1">
                    <div [class.mb-3]="!last">
                        {{owner.membership.name}}<br>
                        {{owner.membership.profile.address1}}<br>
                        <span *ngIf="owner.membership.profile.address2">
                            {{owner.membership.profile.address2}}<br>
                        </span>
                        {{owner.membership.profile.city}}
                        , {{owner.membership.profile.state}} {{owner.membership.profile.zip}}<br/>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>

    <hr *ngIf=hasMailingAddress />

    <app-choose-mail-options
        (optionChange)="options = $event;"
        [doShowPricingGuide]="false"
        [hasFile]="false"
        [whichMailType]="'pdf'"></app-choose-mail-options>
</mat-dialog-content>
<mat-dialog-actions>
    <button (click)="close()" [disabled]="isSendingMail" class="btn btn-outline-secondary">
        Cancel
    </button>
    <button (click)="mailViolation()" [disabled]="isSendingMail" class="btn btn-primary">
        Mail via USPS
    </button>
</mat-dialog-actions>
